import {css} from "styled-components"

const baseRaise = css`
  cursor: pointer;
  box-shadow: ${({theme}) => theme.shadows.low};
  transition: all 0.15s;
  &:hover {
    box-shadow: ${({theme}) => theme.shadows.high};
  }
`
export const hoverRaise = css`
  ${baseRaise}
  &:hover {
    transform: translateY(-3px);
  }
`

export const hoverRaiseWithOverflow = css`
  ${baseRaise}
  position: relative;
  top: 0;
  &:hover {
    top: -3px;
  }
`
